import React from 'react';
const icons = { edit: '✏️', delete: '🗑️', save: '💾', cancel: '❌' };

const ActionIconButton = ({ action, label, className = '', style, ...props }) => {
  const name = label || `${action.charAt(0).toUpperCase()}${action.slice(1)}`;
  return <button type="button" {...props} className={`action-icon-button ${className}`} data-action={action} title={name} aria-label={name} style={{ padding: '0.25rem', backgroundColor: 'transparent', border: 'none', cursor: props.disabled ? 'not-allowed' : 'pointer', fontSize: '14px', ...style }}>
    <span aria-hidden="true">{icons[action]}</span>
  </button>;
};

export default ActionIconButton;